// Gallery: thumbnail swap + prev/next arrows, synced to one current index
// Each media item (image or video) is pre-rendered as a .gallery-slide; switching
// just toggles which slide is visible and plays/pauses any video inside it.
const galleryMainWrap = document.getElementById('galleryMainWrap');
const gallerySlides = galleryMainWrap ? galleryMainWrap.querySelectorAll('.gallery-slide') : [];
const thumbs = document.querySelectorAll('.thumb');
const galleryPrev = document.getElementById('galleryPrev');
const galleryNext = document.getElementById('galleryNext');

// Loading state: images fade in once decoded, and the gallery's sheen placeholder stops as soon as the
// visible slide is ready. The fade class is added here, so without JS the images simply show.
const syncGalleryLoaded = () => {
  const active = galleryMainWrap && galleryMainWrap.querySelector('.gallery-slide.is-active');
  if (!active) return;
  const img = active.querySelector('img');
  galleryMainWrap.classList.toggle('is-loaded', !img || img.classList.contains('is-ready'));
};
if (galleryMainWrap) {
  galleryMainWrap.classList.add('js-fade');
  galleryMainWrap.querySelectorAll('.gallery-slide img').forEach((img) => {
    const ready = () => { img.classList.add('is-ready'); syncGalleryLoaded(); };
    if (img.complete && img.naturalWidth) ready();
    else { img.addEventListener('load', ready, { once: true }); img.addEventListener('error', ready, { once: true }); }
  });
  syncGalleryLoaded();
}

if (gallerySlides.length) {
  let galleryIndex = Array.prototype.findIndex.call(gallerySlides, (s) => s.classList.contains('is-active'));
  if (galleryIndex === -1) galleryIndex = 0;

  // The outgoing slide keeps an .is-leaving class while it fades out, and --gallery-dir
  // tells the CSS which way to glide (1 = forward, -1 = back).
  let leaveTimer = 0;
  const showGalleryImage = (index, dir) => {
    const next = (index + gallerySlides.length) % gallerySlides.length;
    if (next === galleryIndex && gallerySlides[next].classList.contains('is-active')) return;
    const prev = galleryIndex;
    galleryMainWrap.style.setProperty('--gallery-dir', dir || (next > prev ? 1 : -1));
    clearTimeout(leaveTimer);
    gallerySlides.forEach((s) => s.classList.remove('is-leaving'));
    if (gallerySlides[prev] && prev !== next) gallerySlides[prev].classList.add('is-leaving');
    leaveTimer = setTimeout(() => gallerySlides.forEach((s) => s.classList.remove('is-leaving')), 900);
    galleryIndex = next;
    gallerySlides.forEach((slide, i) => {
      const isActive = i === galleryIndex;
      slide.classList.toggle('is-active', isActive);
      const video = slide.querySelector('video');
      if (video) {
        if (isActive) { video.currentTime = 0; video.play().catch(() => {}); }
        else video.pause();
      }
    });
    thumbs.forEach((t, i) => t.classList.toggle('is-active', i === galleryIndex));
    syncGalleryLoaded();
    const activeThumb = thumbs[galleryIndex];
    const strip = activeThumb && activeThumb.parentElement;
    if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: activeThumb.offsetLeft - (strip.clientWidth - activeThumb.clientWidth) / 2, behavior: 'smooth' });
  };

  // Prev/next should only cycle through images visible for the current color, so a
  // color-hidden slide from another variant is skipped rather than briefly flashed.
  const findVisibleIndex = (start, direction) => {
    const total = gallerySlides.length;
    let idx = start;
    for (let step = 0; step < total; step++) {
      idx = (idx + direction + total) % total;
      if (!gallerySlides[idx].classList.contains('is-color-hidden')) return idx;
    }
    return start;
  };

  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => showGalleryImage(i));
  });
  const step = (direction) => showGalleryImage(findVisibleIndex(galleryIndex, direction), direction);
  if (galleryPrev) galleryPrev.addEventListener('click', () => step(-1));
  if (galleryNext) galleryNext.addEventListener('click', () => step(1));

  // Swipe between images on touch screens (horizontal swipes only, so page scrolling still works)
  let touchX = null, touchY = null;
  galleryMainWrap.addEventListener('touchstart', (e) => { touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; }, { passive: true });
  galleryMainWrap.addEventListener('touchend', (e) => {
    if (touchX === null) return;
    const dx = e.changedTouches[0].clientX - touchX, dy = e.changedTouches[0].clientY - touchY;
    touchX = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) step(dx < 0 ? 1 : -1);
  }, { passive: true });

  // Arrow keys when the gallery (or one of its buttons) has focus
  if (!galleryMainWrap.hasAttribute('tabindex')) galleryMainWrap.setAttribute('tabindex', '0');
  galleryMainWrap.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
  });

  // Color variants: each gallery slide/thumb carries the color its image was tagged for
  // (blank for shared/untagged images). The markup already reflects the page's initial
  // variant server-side; this only re-filters when the shopper picks a different color.
  if (galleryMainWrap.dataset.hasColor === 'true') {
    window.filterGalleryByColor = (color) => {
      const target = (color || '').trim().toLowerCase();
      let firstVisible = -1;
      gallerySlides.forEach((slide, i) => {
        const slideColor = slide.dataset.color || '';
        const matches = slideColor === '' || slideColor === target;
        slide.classList.toggle('is-color-hidden', !matches);
        if (matches && firstVisible === -1) firstVisible = i;
      });
      thumbs.forEach((thumb) => {
        const thumbColor = thumb.dataset.color || '';
        thumb.classList.toggle('is-color-hidden', !(thumbColor === '' || thumbColor === target));
      });
      if (firstVisible > -1) showGalleryImage(firstVisible);
    };
  }
}

// Quantity stepper
const qtyValue = document.getElementById('qtyValue');
const qtyMinus = document.getElementById('qtyMinus');
const qtyPlus = document.getElementById('qtyPlus');
if (qtyValue && qtyMinus && qtyPlus) {
  qtyMinus.addEventListener('click', () => {
    const next = Math.max(1, parseInt(qtyValue.value, 10) - 1);
    qtyValue.value = next;
  });
  qtyPlus.addEventListener('click', () => {
    const next = Math.min(10, parseInt(qtyValue.value, 10) + 1);
    qtyValue.value = next;
  });
}

// Accordions
document.querySelectorAll('.accordion').forEach((accordion) => {
  const triggers = accordion.querySelectorAll('.accordion-trigger');
  triggers.forEach((trigger) => {
    const panel = trigger.nextElementSibling;
    if (trigger.getAttribute('aria-expanded') === 'true') {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      trigger.querySelector('.accordion-icon').textContent = isOpen ? '+' : '−';
      panel.style.maxHeight = isOpen ? '0px' : panel.scrollHeight + 'px';
    });
  });
});

// Toast
const toast = document.getElementById('cartToast');
let toastTimer;
function showToast(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('is-visible');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2400);
}

// Real Shopify cart integration — posts to the Cart AJAX API, then jumps straight to the cart page
async function addToCart(variantId, quantity, triggerBtn) {
  if (!variantId) {
    showToast('This product is unavailable');
    return;
  }
  if (triggerBtn) triggerBtn.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    window.location.href = '/cart';
  } catch (err) {
    showToast(err.message || 'Something went wrong');
    if (triggerBtn) triggerBtn.disabled = false;
  }
}

// Variant select (only rendered when a product has more than one variant)
const variantSelect = document.querySelector('[data-variant-select]');
if (variantSelect) {
  variantSelect.addEventListener('change', () => {
    const selected = variantSelect.options[variantSelect.selectedIndex];
    const price = selected.dataset.price;
    const isAvailable = !selected.disabled;
    document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
      btn.dataset.variantId = selected.value;
      btn.disabled = !isAvailable;
      if (btn.id === 'addToCartBtn') {
        btn.textContent = isAvailable ? `Add to Cart — ${selected.textContent.split(' — ')[1] || ''}` : 'Sold out';
      }
    });
    const priceEl = document.querySelector('.price-now');
    if (priceEl && price) {
      priceEl.textContent = (price / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
    }
    if (selected.dataset.color !== undefined && window.filterGalleryByColor) {
      window.filterGalleryByColor(selected.dataset.color);
    }
  });
}

// Per-option chip switchers (rendered only when a product has more than one option).
// These never own the selection — they resolve a combination to a variant, set it on the
// hidden <select>, and fire its change event so the handler above does all the real work.
const optionSwitchers = document.querySelector('[data-option-switchers]');
if (optionSwitchers && variantSelect) {
  const combos = Array.from(variantSelect.options).map((el) => ({
    el,
    values: (el.dataset.options || '').split('|||'),
    available: !el.disabled,
  }));

  const currentValues = () => {
    const sel = variantSelect.options[variantSelect.selectedIndex];
    return (sel && sel.dataset.options ? sel.dataset.options : '').split('|||');
  };

  const selectCombo = (wanted) => {
    // Prefer an in-stock exact match, but still allow selecting a sold-out combination so
    // the shopper sees its price and an honest "Sold out" button rather than a dead chip.
    const match =
      combos.find((c) => c.available && c.values.every((v, i) => v === wanted[i])) ||
      combos.find((c) => c.values.every((v, i) => v === wanted[i]));
    if (!match) return false;
    variantSelect.value = match.el.value;
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  };

  const refreshChips = () => {
    const sel = currentValues();
    optionSwitchers.querySelectorAll('.option-chip').forEach((chip) => {
      const i = Number(chip.dataset.optionIndex);
      const value = chip.dataset.optionValue;
      const isActive = sel[i] === value;
      chip.classList.toggle('is-active', isActive);
      chip.setAttribute('aria-checked', isActive ? 'true' : 'false');
      // Grey out a value only when no in-stock variant pairs it with the other current picks.
      const reachable = combos.some(
        (c) => c.available && c.values[i] === value && c.values.every((v, vi) => vi === i || v === sel[vi])
      );
      chip.classList.toggle('is-unavailable', !reachable);
    });
  };

  optionSwitchers.addEventListener('click', (event) => {
    const chip = event.target.closest('.option-chip');
    if (!chip) return;
    const i = Number(chip.dataset.optionIndex);
    const wanted = currentValues();
    wanted[i] = chip.dataset.optionValue;
    if (!selectCombo(wanted)) {
      // The other picks have no partner for this value — fall back to any variant carrying it
      // so the click still does something predictable instead of silently failing.
      const fallback =
        combos.find((c) => c.available && c.values[i] === chip.dataset.optionValue) ||
        combos.find((c) => c.values[i] === chip.dataset.optionValue);
      if (fallback) {
        variantSelect.value = fallback.el.value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    refreshChips();
  });

  variantSelect.addEventListener('change', refreshChips);
  refreshChips();
}

document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
  btn.addEventListener('click', () => {
    const variantId = btn.dataset.variantId;
    const quantity = qtyValue ? parseInt(qtyValue.value, 10) : 1;
    addToCart(variantId, quantity, btn);
  });
});

// Sticky buy bar — appears as soon as the main Add to Cart button scrolls out of view
const stickyBuyBar = document.getElementById('stickyBuyBar');
const mainAddToCartBtn = document.getElementById('addToCartBtn');
if (stickyBuyBar && mainAddToCartBtn && 'IntersectionObserver' in window) {
  const buyBtnObserver = new IntersectionObserver(
    ([entry]) => {
      stickyBuyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    },
    { threshold: 0 }
  );
  buyBtnObserver.observe(mainAddToCartBtn);
}

// Magnetic buttons — gently pull toward the cursor within a small radius
const magneticButtons = document.querySelectorAll('.btn-magnetic');
if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
  magneticButtons.forEach((btn) => {
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      btn.style.transform = `translate(${x * 0.15}px, ${y * 0.35}px)`;
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = '';
    });
  });
}

// Gallery tilt-on-hover
if (galleryMainWrap && window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
  galleryMainWrap.addEventListener('mousemove', (e) => {
    const rect = galleryMainWrap.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    galleryMainWrap.style.setProperty('--tiltX', `${x * 8}deg`);
    galleryMainWrap.style.setProperty('--tiltY', `${y * -8}deg`);
  });
  galleryMainWrap.addEventListener('mouseleave', () => {
    galleryMainWrap.style.setProperty('--tiltX', '0deg');
    galleryMainWrap.style.setProperty('--tiltY', '0deg');
  });
}
